export default __webpack_public_path__ + "static/media/DKCChaika_logo.4e091a15.jpg";